import moment from 'moment';

export function dateConversion(year, month, day) {
  return moment(new Date(`${year}/${month}/${day}`)).format('YYYY/MM/DD');
}
